import React from 'react'
import actions from 'redux/actions'
import { links } from 'common/helpers'
import { useCallback, useContext } from 'sb-hooks'
import { NotificationContext } from 'sb-notify-me'

import { Svg } from 'components/_new/ui'
import { Row } from 'components/_new/layout'
import { Href } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './NewRecommendations.scss'


const link = `${links.recommendations.history}#result`


const NewRecommendations: React.FunctionComponent = () => {
  const { close } = useContext(NotificationContext)

  const handleClick = useCallback(() => {
    close()

    if (window.location.pathname === links.recommendations.history) {
      actions.models.router.replace(link)
    }
    else {
      actions.models.router.push(link)
    }
  }, [ close ])

  return (
    <Href onClick={handleClick}>
      <Row align="center" justify="start">
        <Svg className={s.icon} name="happyBird" />
        <Text
          size="16-24"
          message={messages.text}
          align="left"
          semibold
          html
        />
      </Row>
    </Href>
  )
}


export default NewRecommendations
